import http from "@/utils/services/http"

export const listTitular = (limit, page, filtros) => {
    let url = '/api/validadeDocumento/titular?page=' + page + '&limit=' + limit + filtros
    return http.get(url)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const findTitular = (id) => {
    let url = `/api/validadeDocumento/titular/${id}`
    return http.get(url)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const newTitular = (data) => {
    let url = `/api/validadeDocumento/titular`
    return http.post(url, data)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const updateTitular = (id, data, method = 'PUT') => {
    let url = `/api/validadeDocumento/titular/${id}`
    let _method = http.put
    if (method === 'PATCH') {
        _method = http.patch
    }
    return _method(url, data)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const deleteTitular = (id) => {
    let url = `/api/validadeDocumento/titular/${id}`
    return http.delete(url)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}
